var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-story-title",class:_vm.storyTitleClass},[(_vm.storyLogo !== null)?[_c(_vm.storyLogo,{tag:"component"})]:[_c('p',[_vm._v(_vm._s(_vm.storyData.title))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }